<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form :inline="false" label-position="top" size="small">
        <el-row
          :gutter="20" justify="left" style="flex-wrap: wrap"
          type="flex"
        >
          <el-col :span="4">
            <!--  停更天数   -->
            <el-form-item :label="$t('customerManagements.daysStop')">
              <el-select
                v-model="queryForm.params.daysDelayed"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in dayList" :key="item" :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 运单状态 -->
            <el-form-item :label="$t('newOrder.waybillStatus')">
              <el-select
                v-model="queryForm.params.waybillStatusList"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="(item, ind) in waybillStatusPageList"
                  :key="ind"
                  :label="item.label"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--  轨迹停更大区   -->
            <el-form-item :label="$t('customerManagements.trackingStalledRegion')">
              <el-select
                v-model="queryForm.params.regionId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="regionChange"
              >
                <el-option
                  v-for="(item, ind) in regionList"
                  :key="ind"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--  轨迹停更州   -->
            <el-form-item :label="$t('customerManagements.trackingStalledState')">
              <el-select
                v-model="queryForm.params.latestTraceStateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
                @change="stateChange"
              >
                <el-option
                  v-for="(item, ind) in allTraceStateList"
                  :key="ind"
                  :label="item.nameEn"
                  :value="item.twoCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="flx-between">
              <div>
                <!--搜索-->
                <el-button
                  icon="el-icon-search" size="small" type="primary"
                  @click="enterSearch"
                >{{ $t('newOrder.search') }}
                </el-button>
                <!--高级搜索-->
                <el-button
                  size="small" type="primary"
                  @click="advancedSearch"
                >{{ $t('home.advancedSearch') }}
                </el-button>
                <!--重置-->
                <el-button
                  icon="el-icon-refresh-left" size="small" @click="resetForm()"
                >{{ $t('newOrder.reset') }}
                </el-button>
                <el-button
                  icon="el-icon-upload2"
                  size="small"
                  style="margin-bottom: 10px"
                  type="primary"
                  @click="allExportOrder"
                >{{ $t('newOrder.export') }}
                </el-button>
                <el-radio-group
                  v-model="queryForm.params.isTest"
                  size="small"
                  style="margin-left: 10px"
                  @change="enterSearch"
                >
                  <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
                  <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
                </el-radio-group>
              </div>
              <div>
                <el-checkbox v-model="queryForm.params.dataTypeBool">
                  {{ $t('customerManagements.allData') }}
                </el-checkbox>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 已选条件（仅展示高级搜索内的条件） -->
      <div v-if="getSelectedConditions().length" class="selected-conditions">
        <span class="selected-label">
          <i class="el-icon-filter" />
          {{ $t('seller.selectedConditions') }}:
        </span>
        <el-tag
          v-for="item in getSelectedConditions()"
          :key="item.key"
          class="selected-tag"
          closable
          size="medium"
          @close="removeCondition(item.key)"
        >
          {{ item.label }}: {{ item.value }}
        </el-tag>
        <el-button class="clear-all-btn" type="text" @click="clearAllConditions">
          <i class="el-icon-delete" />
          {{ $t('seller.clearAll') }}
        </el-button>
      </div>
    </el-card>
    <el-card>
      <!--  表格数据  -->
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
      >
        <el-table-column
          :label="`${$t('GlobalSetObj.serial', 'zh')}（${$t('GlobalSetObj.serial', 'pu')}）`"
          align="center"
          type="index"
          width="80"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'waybillNumber'">
              <div style="color: #00A551; cursor: pointer" @click="toOrderDetail(scope.row)">
                {{ scope.row.waybillNumber }}
              </div>
            </div>
            <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--详情-->
    <el-drawer
      :append-to-body="true"
      :visible.sync="waybillDescription"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <detailPage :key="detailKey" :query-track-param="queryTrackParam" query-type="1" />
      </div>
    </el-drawer>
    <!--  高级搜索 -->
    <search-com
      ref="searchComRef"
      :site-list="siteList"
      :transfer-list="TransferList"
      :cargo-type-list="CARGO_TYPE"
      :default-time-value="timeValue"
      @search="advancedSearchEvent"
    />
  </div>
</template>

<script>
import {
  getLgAreaListData,
  getMerchantByCustomerIdList,
  getSiteTransfer,
  regionQueryList,
  selectInfoByStateTwo,
  stationaryTrackMonitorPage,
  stationaryTrackMonitorPageexport
} from '@/api/orderApi';
import detailPage from '@/components/detailComponent/detailPage';
// import _debounce from '@/utils/tools';
import { waybillStatusList } from '@/utils/enumData';
import { goResourceTaskList } from '@/utils/goExportList';
import { apiCustomerPage } from '@/api/customer';
import dayjs from 'dayjs';
import { CARGO_TYPE } from '@/views/finance/basicData/quotationManagement/cmp/utils';
import searchCom from './searchCom.vue';

export default {
  name: 'NewSortingRules',
  components: {
    detailPage,
    searchCom
  },
  data() {
    return {
      CARGO_TYPE,
      timeValue: [],
      defaultTimeValue: [], // 页面默认时间范围（用于判断时间是否被改动过）
      merchantList: [], // 商户列表
      customerList: [], // 客户列表
      sitesByRegionAndState: {}, // 保存大区下所有网点，后续根据州过滤
      regionList: [],
      // 详情
      waybillDescription: false,
      detailKey: new Date().getTime(),
      queryTrackParam: {},
      isTormat: false,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          createStartTime: '',
          createEndTime: '',
          isTest: 1,
          inputValue: '',
          waybillStatusList: [],
          latestTraceStateList: [], // 最新轨迹州
          selectType: 1,
          daysDelayed: [],
          latestTraceSiteList1: [],
          upTransferList1: [],
          selectType1: 1,
          selectType2: 1,
          dataTypeBool: false,
          regionId: '',
          customerIdList: [],
          merchantCodeList: [],
          cargoType: 0 // 货物类型
        }
      },
      siteList: [], // 网点
      tableData: [],
      TransferList: [], // 上级转运中心
      allTraceStateList: [], // 全部州
      tableHeaderList: [
        // 运单号
        {
          id: 1,
          label: `${this.$t('GlobalSetObj.waybillNumber', 'zh')}（${this.$t(
            'GlobalSetObj.waybillNumber',
            'pu'
          )}）`,
          prop: 'waybillNumber',
          cloWidth: 170
        },
        // 扫描单号
        {
          id: 2,
          label: `${this.$t('GlobalSetObj.ScanNumber', 'zh')}（${this.$t(
            'GlobalSetObj.ScanNumber',
            'pu'
          )}）`,
          prop: 'scanNumber',
          cloWidth: 170
        },
        // 停更天数
        {
          id: 3,
          label: `${this.$t('customerManagements.daysStop', 'zh')}（${this.$t(
            'customerManagements.daysStop',
            'pu'
          )}）`,
          prop: 'daysDelayed',
          cloWidth: 150
        },
        // 运单状态
        {
          id: 4,
          label: `${this.$t('newOrder.waybillStatus', 'zh')}（${this.$t(
            'newOrder.waybillStatus',
            'pu'
          )}）`,
          prop: 'status',
          cloWidth: 180
        },
        // 轨迹停更大区
        {
          id: 4,
          label: `${this.$t('customerManagements.trackingStalledRegion', 'zh')}（${this.$t(
            'customerManagements.trackingStalledRegion',
            'pu'
          )}）`,
          prop: 'regionName',
          cloWidth: 180
        },
        // 轨迹停更州
        {
          id: 4,
          label: `${this.$t('customerManagements.trackingStalledState', 'zh')}（${this.$t(
            'customerManagements.trackingStalledState',
            'pu'
          )}）`,
          prop: 'latestTraceState',
          cloWidth: 180
        },
        // 轨迹停更网点
        {
          id: 4,
          label: `${this.$t('customerManagements.trackingStalledLocation', 'zh')}（${this.$t(
            'customerManagements.trackingStalledLocation',
            'pu'
          )}）`,
          prop: 'latestTraceSiteName',
          cloWidth: 180
        },
        // 订单创建时间
        {
          id: 5,
          label: `${this.$t('collectionCenter.orderCreateT', 'zh')}（${this.$t(
            'collectionCenter.orderCreateT',
            'pu'
          )}）`,
          prop: 'createTime',
          cloWidth: 180
        },
        // 下一站
        {
          id: 6,
          label: `${this.$t('GlobalSetObj.nextStation', 'zh')}（${this.$t(
            'GlobalSetObj.nextStation',
            'pu'
          )}）`,
          prop: 'nextSiteName',
          cloWidth: 180
        },
        // 客户
        {
          id: 7,
          label: `${this.$t('collectionCenter.client', 'zh')}（${this.$t(
            'collectionCenter.client',
            'pu'
          )}）`,
          prop: 'customerName',
          cloWidth: 180
        },
        // 商户
        {
          id: 8,
          label: `${this.$t('collectionCenter.CommercialOwner', 'zh')}（${this.$t(
            'collectionCenter.CommercialOwner',
            'pu'
          )}）`,
          prop: 'merchantName',
          cloWidth: 180
        },
        // 最新轨迹时间
        {
          id: 9,
          label: `${this.$t('newOrder.LatestTime', 'zh')}（${this.$t(
            'newOrder.LatestTime',
            'pu'
          )}）`,
          prop: 'latestTraceTime',
          cloWidth: 180
        },
        // 最新轨迹内容
        {
          id: 10,
          label: `${this.$t('orderCenterCont.zuixinguijineir', 'zh')}（${this.$t(
            'orderCenterCont.zuixinguijineir',
            'pu'
          )}）`,
          prop: 'latestTraceContent',
          cloWidth: 180
        },
        // 问题原因
        {
          id: 11,
          label: `${this.$t('orderCenterCont.wentijianyuanyin', 'zh')}（${this.$t(
            'orderCenterCont.wentijianyuanyin',
            'pu'
          )}）`,
          prop: 'problemReason',
          cloWidth: 180
        },
        // 最新轨迹上级转运中心
        {
          id: 14,
          label: `${this.$t('customerManagements.newupTransferName', 'zh')}（${this.$t(
            'customerManagements.newupTransferName',
            'pu'
          )}）`,
          prop: 'upTransferName',
          cloWidth: 170
        },
        // 次新上级转运中心
        {
          id: 16,
          label: `${this.$t('customerManagements.nextNewTransferName', 'zh')}（${this.$t(
            'customerManagements.nextNewTransferName',
            'pu'
          )}）`,
          prop: 'nextNewTransferName',
          cloWidth: 180
        },
        // 最新轨迹操作账号
        {
          id: 17,
          label: `${this.$t('customerManagements.latestTraceOperatorName', 'zh')}（${this.$t(
            'customerManagements.latestTraceOperatorName',
            'pu'
          )}）`,
          prop: 'latestTraceOperatorName',
          cloWidth: 200
        },
        // 次新操作人
        {
          id: 18,
          label: `${this.$t('customerManagements.nextNewOperatorName', 'zh')}（${this.$t(
            'customerManagements.nextNewOperatorName',
            'pu'
          )}）`,
          prop: 'nextNewOperatorName',
          cloWidth: 180
        },
        // 次新操作名称
        {
          id: 19,
          label: `${this.$t('customerManagements.nextNewOperateTypeName', 'zh')}（${this.$t(
            'customerManagements.nextNewOperateTypeName',
            'pu'
          )}）`,
          prop: 'nextNewOperateTypeName',
          cloWidth: 180
        },
        // 次新操作人网点
        {
          id: 20,
          label: `${this.$t('customerManagements.operatorNameSite', 'zh')}（${this.$t(
            'customerManagements.operatorNameSite',
            'pu'
          )}）`,
          prop: 'nextNewOperatorSiteName',
          cloWidth: 180
        },
        // 收件人城市
        {
          id: 21,
          label: `${this.$t('newOrder.RecipientCity', 'zh')}（${this.$t(
            'newOrder.RecipientCity',
            'pu'
          )}）`,
          prop: 'receiveCity',
          cloWidth: 180
        },
        // 预派送网点
        {
          id: 22,
          label: `${this.$t('GlobalSetObj.preEntrega', 'zh')}（${this.$t(
            'GlobalSetObj.preEntrega',
            'pu'
          )}）`,
          prop: 'preDeliverStationName',
          cloWidth: 180
        },
        // 实际入库网点
        {
          id: 23,
          label: `${this.$t('GlobalSetObj.infeatSite', 'zh')}（${this.$t(
            'GlobalSetObj.infeatSite',
            'pu'
          )}）`,
          prop: 'warehouseStationName',
          cloWidth: 180
        },
        // 网点入库时间
        {
          id: 24,
          label: `${this.$t('newOrder.StorageTimeOutlets', 'zh')}（${this.$t(
            'newOrder.StorageTimeOutlets',
            'pu'
          )}）`,
          prop: 'dispatchReceiptTime',
          cloWidth: 180
        },
        // 货物类型
        {
          id: 25,
          label: `${this.$t('placeOrder.cargoType', 'zh')}（${this.$t(
            'placeOrder.cargoType',
            'pu'
          )}）`,
          prop: 'cargoTypeName',
          cloWidth: 100
        }
      ],
      dayList: [1, 2, 3, 7, 15, 20, 30, 50],
      waybillStatusPageList: waybillStatusList
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '220px' : '120px'
      };
    },
    IsWidth2() {
      return {
        width: this.isTormat ? '280px' : '180px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    const d = new Date();
    const today = dayjs(d).format('YYYY-MM-DD 23:59:59');
    const day = dayjs(d).subtract(1, 'month').format('YYYY-MM-DD 00:00:00');
    this.timeValue = [day, today];
    this.defaultTimeValue = [day, today];
    this.getSearch();
    this.getSiteTransfer();
    this.getSiteList();
    this.getTraceStateList();
    this.getRegion();
  },
  methods: {
    getMerchantList(val) {
      if (!val || val.length === 0) {
        this.queryForm.params.merchantCodeList = [];
        this.merchantList = [];
        return;
      }
      const form = {
        customerIdList: val
      };
      getMerchantByCustomerIdList(form).then((res) => {
        if (res.code === 200) {
          this.merchantList = res.data;
        }
      });
    },
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerList.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerList = res.data.records;
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerList = res.data.records;
          }
        });
      }
    },
    regionChange(newVal) {
      // 大区单选，州多选，网点多选
      this.queryForm.params.latestTraceStateList = [];
      this.queryForm.params.latestTraceSiteList1 = [];
      if (!newVal || newVal.length === 0 || this.regionList.length === 0) {
        this.allTraceStateList = [];
        this.getTraceStateList();
        this.siteList = [];
        this.getSiteList();
        return;
      }
      const selectedRegion = this.regionList.find((item) => item.id === newVal);
      if (selectedRegion && Array.isArray(selectedRegion.states)) {
        this.siteList = selectedRegion?.sites || [];
        this.allTraceStateList = selectedRegion.states.map((state) => ({
          nameEn: state,
          twoCode: state
        }));
        this.groupSitesByRegionAndState();
      } else {
        this.siteList = [];
        this.allTraceStateList = [];
      }
    },
    stateChange(val) {
      this.queryForm.params.latestTraceSiteList1 = [];
      const regionId = this.queryForm.params.regionId;
      if (!regionId && val && val.length > 0) {
        if (this.allTraceStateList) {
          this.siteList = this.allTraceStateList;
        } else {
          this.getSiteList();
        }
      } else if (regionId && (!val || val.length <= 0)) {
        const selectedRegion = this.regionList.find((r) => r.id === regionId);
        this.siteList = selectedRegion?.sites || [];
      } else if (regionId && val && val.length > 0) {
        const mergedSites = [];
        val.forEach((state) => {
          const sitesInState = this.sitesByRegionAndState[regionId]?.[state] || [];
          mergedSites.push(...sitesInState);
        });
        this.siteList = mergedSites;
      } else {
        this.getSiteList();
      }
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 获取轨迹州列表
    getTraceStateList() {
      const param = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(param, false).then((res) => {
        if (res.code === 200) {
          this.allTraceStateList = res.data;
        }
      });
    },
    groupSitesByRegionAndState() {
      const grouped = {};
      this.regionList.forEach((region) => {
        if (!grouped[region.id]) {
          grouped[region.id] = {};
        }

        region.sites.forEach((site) => {
          const key = site.state;
          if (!grouped[region.id][key]) {
            grouped[region.id][key] = [];
          }
          grouped[region.id][key].push(site);
        });
      });

      this.sitesByRegionAndState = grouped;
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 打开高级搜索弹窗
    advancedSearch() {
      this.$refs.searchComRef.showDialog();
    },
    // 高级搜索查询
    advancedSearchEvent({ params, timeValue }) {
      Object.assign(this.queryForm.params, params);
      if (timeValue && timeValue.length > 0) {
        this.timeValue = timeValue;
      }
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      const d = new Date();
      const today = dayjs(d).format('YYYY-MM-DD 23:59:59');
      const day = dayjs(d).subtract(1, 'month').format('YYYY-MM-DD 00:00:00');
      this.timeValue = [day, today];
      this.defaultTimeValue = [day, today];
      this.queryForm.pageNumber = 1;
      this.queryForm.params = {
        createStartTime: day,
        createEndTime: today,
        isTest: 1,
        inputValue: '',
        waybillStatusList: [],
        selectType: 1,
        daysDelayed: [],
        latestTraceStateList: [],
        latestTraceSiteList1: [],
        upTransferList1: [],
        selectType1: 1,
        selectType2: 1,
        dataTypeBool: false,
        regionId: '',
        customerIdList: [],
        merchantCodeList: [],
        cargoType: 0
      };
      // 同步重置高级搜索内的查询条件
      if (this.$refs.searchComRef) {
        this.$refs.searchComRef.handleReset();
      }
      this.getSearch();
      this.getRegion();
      this.getTraceStateList();
      this.getSiteList();
      this.getCustomerPage('');
    },
    // 查询
    getSearch() {
      // 同步高级搜索未提交的查询条件（未点"搜索"直接关闭也能生效）
      if (this.$refs.searchComRef && this.$refs.searchComRef.getLocalParams) {
        const localParams = this.$refs.searchComRef.getLocalParams();
        if (localParams.timeValue && localParams.timeValue.length > 0) {
          this.timeValue = [...localParams.timeValue];
        }
        delete localParams.timeValue;
        Object.assign(this.queryForm.params, localParams);
      }
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params = this.queryForm.params;
      data.params.dataType = this.queryForm.params.dataTypeBool ? 2 : 1;
      data.params.customerIdList = this.queryForm.params.customerIdList;
      data.params.merchantCodeList = this.queryForm.params.merchantCodeList;
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      if (this.queryForm.params.selectType === 1) {
        data.params.waybillNumberList = inputValList.filter((item) => item !== '');
        data.params.scanNumberList = [];
      } else {
        data.params.scanNumberList = inputValList.filter((item) => item !== '');
        data.params.waybillNumberList = [];
      }
      if (this.queryForm.params.selectType1 === 1) {
        data.params.nextNewOperatorSiteList = [];
        data.params.latestTraceSiteList = this.queryForm.params.latestTraceSiteList1;
      } else {
        data.params.nextNewOperatorSiteList = this.queryForm.params.latestTraceSiteList1;
        data.params.latestTraceSiteList = [];
      }
      if (this.queryForm.params.selectType2 === 1) {
        data.params.nextNewTransferList = [];
        data.params.upTransferList = this.queryForm.params.upTransferList1;
      } else {
        data.params.nextNewTransferList = this.queryForm.params.upTransferList1;
        data.params.upTransferList = [];
      }
      if (
        this.queryForm.params.latestTraceStateList &&
        this.queryForm.params.latestTraceStateList.length > 0
      ) {
        data.params.latestTraceStateList = this.queryForm.params.latestTraceStateList;
      } else {
        data.params.latestTraceStateList = [];
      }
      data.params.createStartTime = '';
      data.params.createEndTime = '';
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.createStartTime = this.timeValue[0];
        data.params.createEndTime = this.timeValue[1];
      }
      stationaryTrackMonitorPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          console.log(this.tableData, '===this.tableData');
          this.tableData.map((item) => {
            item.supplierName = item.providerChannelName;
            // if (waybillStatusObj[item.waybillStatus].label) {
            //   item.statusNamewaybill = waybillStatusObj[item.waybillStatus].label;
            // }
          });
        }
      });
    },
    allExportOrder() {
      const data = this.queryForm.params;
      data.dataType = this.queryForm.params.dataTypeBool ? 2 : 1;
      data.customerIdList = this.queryForm.params.customerIdList;
      data.merchantCodeList = this.queryForm.params.merchantCodeList;
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      if (this.queryForm.params.selectType === 1) {
        data.waybillNumberList = inputValList;
        data.scanNumberList = [];
      } else {
        data.scanNumberList = inputValList;
        data.waybillNumberList = [];
      }
      if (this.queryForm.params.selectType1 === 1) {
        data.nextNewOperatorSiteList = [];
        data.latestTraceSiteList = this.queryForm.params.latestTraceSiteList1;
      } else {
        data.nextNewOperatorSiteList = this.queryForm.params.latestTraceSiteList1;
        data.latestTraceSiteList = [];
      }
      if (this.queryForm.params.selectType2 === 1) {
        data.nextNewTransferList = [];
        data.upTransferList = this.queryForm.params.upTransferList1;
      } else {
        data.nextNewTransferList = this.queryForm.params.upTransferList1;
        data.upTransferList = [];
      }
      if (
        this.queryForm.params.latestTraceStateList &&
        this.queryForm.params.latestTraceStateList.length > 0
      ) {
        data.latestTraceStateList = this.queryForm.params.latestTraceStateList;
      } else {
        data.latestTraceStateList = [];
      }
      data.createStartTime = '';
      data.createEndTime = '';
      if (this.timeValue && this.timeValue.length > 0) {
        data.createStartTime = this.timeValue[0];
        data.createEndTime = this.timeValue[1];
      }
      console.log(data, '===data.params');
      stationaryTrackMonitorPageexport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 进入运单详情
    toOrderDetail(row) {
      this.queryTrackParam = row;
      console.log(row, ':query-track-param="queryTrackParam"');
      this.waybillDescription = true;
      this.detailKey = new Date().getTime();
      setTimeout(() => {
        this.bus.$emit('todetailBox', row.waybillId);
      }, 100);
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 获取网点列表
    getSiteList() {
      const data = {};
      selectInfoByStateTwo(data).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data.siteList;
        }
      });
    },
    getSiteTransfer() {
      getSiteTransfer().then((res) => {
        if (res.code === 200) {
          this.TransferList = res.data;
        }
      });
    },
    // 客户 id -> 名称
    getCustomerName(id) {
      const ref = this.$refs.searchComRef;
      const list = (ref && ref.customerList) || [];
      const item = list.find((c) => c.id === id);
      return item ? `${item.customerAlias}(${item.username})` : id;
    },
    // 商户 code -> 名称
    getMerchantName(code) {
      const ref = this.$refs.searchComRef;
      const list = (ref && ref.merchantList) || [];
      const item = list.find((m) => m.merchantCode === code);
      return item ? `${item.merchantName}（${item.merchantCode}）` : code;
    },
    // 网点 id -> 名称
    getSiteName(id) {
      const item = (this.siteList || []).find((s) => s.id === id);
      return item ? item.name : id;
    },
    // 转运中心 id -> 名称
    getTransferName(id) {
      const item = (this.TransferList || []).find((t) => t.id === id);
      return item ? item.name : id;
    },
    // 已选条件展示数据（仅展示高级搜索抽屉内的条件）
    getSelectedConditions() {
      const list = [];
      const p = this.queryForm.params;

      // 单号（运单号 / 扫描单号）
      if (p.inputValue) {
        const vals = p.inputValue
          .split('\n')
          .filter((s) => s && s.trim());
        if (vals.length) {
          list.push({
            key: 'inputValue',
            label:
              p.selectType === 1
                ? this.$t('newOrder.waybillNumber')
                : this.$t('GlobalSetObj.ScanNumber'),
            value: vals.join(', ')
          });
        }
      }

      // 货物类型（0 为页面默认值，不展示）
      if (p.cargoType !== null && p.cargoType !== undefined && p.cargoType !== 0) {
        const cargo = this.CARGO_TYPE[p.cargoType];
        list.push({
          key: 'cargoType',
          label: this.$t('placeOrder.cargoType'),
          value: cargo ? cargo.name : p.cargoType
        });
      }

      // 订单创建时间（与页面默认时间一致时不展示）
      const time = this.timeValue || [];
      const defaultTime = this.defaultTimeValue || [];
      const isDefaultTime =
        time.length === 2 &&
        defaultTime.length === 2 &&
        time[0] === defaultTime[0] &&
        time[1] === defaultTime[1];
      if (time.length > 0 && !isDefaultTime) {
        list.push({
          key: 'timeValue',
          label: this.$t('collectionCenter.orderCreateT'),
          value: time.join(' ~ ')
        });
      }

      // 客户
      if (p.customerIdList && p.customerIdList.length) {
        list.push({
          key: 'customerIdList',
          label: this.$t('collectionCenter.client'),
          value: p.customerIdList.map((id) => this.getCustomerName(id)).join(', ')
        });
      }

      // 商户
      if (p.merchantCodeList && p.merchantCodeList.length) {
        list.push({
          key: 'merchantCodeList',
          label: this.$t('collectionCenter.CommercialOwner'),
          value: p.merchantCodeList.map((code) => this.getMerchantName(code)).join(', ')
        });
      }

      // 轨迹停更网点 / 次新操作人网点
      if (p.latestTraceSiteList1 && p.latestTraceSiteList1.length) {
        list.push({
          key: 'latestTraceSiteList1',
          label:
            p.selectType1 === 1
              ? this.$t('customerManagements.trackingStalledLocation')
              : this.$t('customerManagements.operatorNameSite'),
          value: p.latestTraceSiteList1.map((id) => this.getSiteName(id)).join(', ')
        });
      }

      // 最新轨迹上级转运中心 / 次新上级转运中心
      if (p.upTransferList1 && p.upTransferList1.length) {
        list.push({
          key: 'upTransferList1',
          label:
            p.selectType2 === 1
              ? this.$t('customerManagements.newupTransferName')
              : this.$t('customerManagements.nextNewTransferName'),
          value: p.upTransferList1.map((id) => this.getTransferName(id)).join(', ')
        });
      }

      return list;
    },
    // 移除单个已选条件
    removeCondition(key) {
      const p = this.queryForm.params;
      const ref = this.$refs.searchComRef;
      switch (key) {
        case 'inputValue':
          p.inputValue = '';
          p.selectType = 1;
          if (ref) {
            ref.localParams.inputValue = '';
            ref.localParams.selectType = 1;
          }
          break;
        case 'cargoType':
          p.cargoType = 0;
          if (ref) ref.localParams.cargoType = 0;
          break;
        case 'timeValue':
          this.timeValue = [];
          if (ref) ref.localParams.timeValue = [];
          break;
        case 'customerIdList':
          // 商户依赖客户，一并清空
          p.customerIdList = [];
          p.merchantCodeList = [];
          if (ref) {
            ref.localParams.customerIdList = [];
            ref.localParams.merchantCodeList = [];
          }
          break;
        case 'merchantCodeList':
          p.merchantCodeList = [];
          if (ref) ref.localParams.merchantCodeList = [];
          break;
        case 'latestTraceSiteList1':
          p.latestTraceSiteList1 = [];
          p.selectType1 = 1;
          if (ref) {
            ref.localParams.latestTraceSiteList1 = [];
            ref.localParams.selectType1 = 1;
          }
          break;
        case 'upTransferList1':
          p.upTransferList1 = [];
          p.selectType2 = 1;
          if (ref) {
            ref.localParams.upTransferList1 = [];
            ref.localParams.selectType2 = 1;
          }
          break;
        default:
          break;
      }
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 清空全部已选条件（仅清空高级搜索内的条件）
    clearAllConditions() {
      this.resetForm();
    }
  }
};
</script>

<style scoped>
.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
}

.app-container >>> .el-form--label-top .el-form-item__label {
  width: 100% !important;
}

.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
}

.app-container >>> .selectLabel .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep.el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

::v-deep .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.selected-conditions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  clear: both;
  width: 100%;
  padding: 5px 0;
  gap: 8px;
  margin-top: 10px;
}

.selected-conditions .selected-label {
  font-weight: bold;
  color: #303133;
  margin-right: 4px;
}

.selected-conditions .selected-tag {
  background: #f4f4f5;
  border-color: #e9e9eb;
  color: #606266;
}

.selected-conditions .clear-all-btn {
  margin-left: auto;
  color: #67c23a;
}

.selected-conditions .clear-all-btn:hover {
  color: #85ce61;
}
</style>
